import React, {createContext, useContext, useState, useEffect} from 'react'
import {fetchKnownNextPaths} from './knownNextPaths'

export const KnownNextPathsContext = createContext([])

export const KnownNextPathsProvider = ({children}) => {
  const [knownNextPaths, setKnownNextPaths] = useState([])

  useEffect(() => {
    async function loadPaths() {
      const paths = await fetchKnownNextPaths()
      setKnownNextPaths(paths)
    }
    loadPaths()
  }, [])

  return <KnownNextPathsContext.Provider value={knownNextPaths}>{children}</KnownNextPathsContext.Provider>
}

export const useKnownNextPaths = () => useContext(KnownNextPathsContext)
